import styled from 'styled-components';
import { Input } from 'antd';
// Abstracts
import * as palette from '../../styles/variables';

export const Container = styled(Input)`
  .ant-input {
    font-size: 15px;
    font-weight: 600;
    color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR};
    border-color: transparent;
    border-radius: 4px;
    text-transform:uppercase;
    background: transparent;
    &:hover,
    &:focus {
      border-color: transparent;
      box-shadow: initial;
    }
    @media only screen and (min-width: 1460px){
        font-size: 12px;
    }
  }
  &.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR}; !important;
  }
  &.ant-input-affix-wrapper {
    text-align: center;
    width: ${props => props.width ? props.width: '350px'}; !important;
    &:hover,
    &:focus {
      .ant-input {
        border-color:transparent !important;
      }
    }
  }
  .ant-input[disabled] {
    color: ${palette.WHITE_COLOR};
    background-color: transparent;
    cursor: pointer;
  }
  .ant-input:placeholder-shown {
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-size: 16px;
      color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR};
      opacity: 0.7;
      font-weight: normal;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      font-size: 16px;
      color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR};
      opacity: 0.7;
      font-weight: normal;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      font-size: 16px;
      color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR};
      opacity: 0.7;
      font-weight: normal;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      font-size: 16px;
      color: ${props => props.inverted ? "rgb(43, 42, 53)" : palette.WHITE_COLOR};
      opacity: 0.7;
      font-weight: normal;
    }
  }
`;
